import React from 'react';

import styles from './header.css';

class Header extends React.Component {
	render() {
		return <nav className={`uk-navbar-container uk-navbar-transparent ${styles.header}`} uk-navbar="true">
			<div className="uk-navbar-left">
				<h1 className={`uk-nav-header ${styles.brand}`}>Pratyush<span className={styles.lastName}> Singh</span></h1>
      </div>
			<div className="uk-navbar-right">
				<ul className="uk-navbar-nav">
          {/* <li><a href="#" className={[styles.headerLink].join(' ')}>XP</a></li> */}
          <li><a href="https://medium.com/@singhpratyush" target='_blank' rel="noopener noreferrer" className={styles.headerLink}>BLOG</a></li>
        </ul>
      </div>
    </nav>
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js